import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["blockRID", "view", "allViews", "changeView", "completeInteraction", "cancelInteraction", "paramSources", "contractSources"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Block } from './Block';

/**
 * The props of an extension component.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export function createBlockExtension(Component) {
  return function (_ref) {
    var piral = _ref.piral,
      _ref$params = _ref.params,
      blockRID = _ref$params.blockRID,
      view = _ref$params.view,
      allViews = _ref$params.allViews,
      changeView = _ref$params.changeView,
      completeInteraction = _ref$params.completeInteraction,
      cancelInteraction = _ref$params.cancelInteraction,
      paramSources = _ref$params.paramSources,
      contractSources = _ref$params.contractSources,
      componentProps = _objectWithoutProperties(_ref$params, _excluded);
    var blockParams = {
      blockRID: blockRID,
      view: view,
      allViews: allViews,
      changeView: changeView,
      completeInteraction: completeInteraction,
      cancelInteraction: cancelInteraction,
      paramSources: paramSources,
      contractSources: contractSources
    };
    return /*#__PURE__*/_jsx(Block, _objectSpread(_objectSpread({
      piletApi: piral
    }, blockParams), {}, {
      children: /*#__PURE__*/_jsx(Component, _objectSpread({
        piletApi: piral,
        blockRID: blockRID
      }, componentProps))
    }));
  };
}